<template>
  <div class="">
    <h3 class="pt-0 mt-0 pb-0">
      {{ $t("viewSettings.repairtime_types.title") }}
    </h3>
    <v-card class="mt-2" elevation="0">
      <v-flex xs12 lg6>
        <v-form ref="repairTimeTypeForm">
          <v-text-field
            outlined
            v-if="fetched || !!this.$route.params.id"
            :rules="[
              (v) => !!v || $t('form.validationErrors.field_is_required'),
            ]"
            :value="currentRepairTimeType.price"
            v-model="currentRepairTimeType.price"
            :label="$t('common.price')"
          ></v-text-field>
          <v-divider></v-divider>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="savingInProgress"
            :loading="savingInProgress"
            class="mt-5 white--text mr-4"
            elevation="0"
            color="red"
            @click="$router.push({ name: 'settings-repairtime-types' })"
            @keyup.enter="$router.push({ name: 'settings-repairtime-types' })"
          >
            {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            :disabled="savingInProgress"
            :loading="savingInProgress"
            class="mt-5"
            elevation="0"
            color="primary"
            @click="submit"
            @keyup.enter="submit"
          >
            {{ $t("common.save") }}
          </v-btn>
        </v-form>
      </v-flex>
    </v-card>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  name: "RepairTimeTypeForm",
  data: () => ({
    emptyRepairTimeType: {
      name: "",
      price: null,
    },
    currentRepairTimeType: {
      name: "",
      price: null,
    },
  }),
  created() {
    this.onLoad();
  },

  watch: {
    $route(to, from) {
      this.onLoad();
    },
  },
  computed: {
    ...mapFields("repairtimes", [
      "repairtimetypes",
      "fetched",
      "savingInProgress",
    ]),
  },
  methods: {
    onLoad() {
      if (this.$route.params.id > 0) {
        this.$store.dispatch("repairtimes/typesGet").then(() => {
          let item = this.repairtimetypes.filter(
            (item) => Number(item.id) === Number(this.$route.params.id)
          );
          if (!item) {
            this.$router.push({ name: "404" });
          } else {
            this.currentRepairTimeType = Object.assign(
              this.currentRepairTimeType,
              item[0]
            );
          }
        });
      }
    },
    submit() {
      if (this.$refs["repairTimeTypeForm"].validate()) {
        if (this.$route.params.id > 0) {
          this.$store
            .dispatch(
              "repairtimes/updateRepairTimeType",
              this.currentRepairTimeType
            )
            .then((id) => {
              if (id > 0) {
                this.$store.dispatch("repairtimes/typesGet");
                this.$router.push({ name: "settings-repairtime-types" });
              }
            });
        } else {
          this.$store
            .dispatch(
              "repairtimes/storeRepairTimeType",
              this.currentRepairTimeType
            )
            .then((id) => {
              if (id > 0) {
                this.$store.dispatch("repairtimes/typesGet");
                this.$router.push({ name: "settings-repairtime-types" });
              }
            });
        }
      }
    },
  },
};
</script>

<style scoped></style>
